export const EVALUATION_VISIBLE_STATUSES = [
	"EVALUATION",
	"AWARDED",
	"COMPLETE",
] as const;

export const EVALUATION_STEP_IDS = {
	CRITERIA: 1,
	INITIAL: 2,
	CLARIFICATIONS: 3,
	REVISIONS: 4,
	FINAL: 5,
} as const;

export const EVALUATION_STEP_META = [
	{
		id: EVALUATION_STEP_IDS.CRITERIA,
		name: "Evaluation Criteria",
		description: "Set up the criteria that will be used to score each supplier",
		info: "Define the criteria for evaluating submissions",
	},
	{
		id: EVALUATION_STEP_IDS.INITIAL,
		name: "Initial Evaluation",
		description: "Score each supplier against the evaluation criteria",
		info: "Score each supplier against the evaluation criteria",
	},
	{
		id: EVALUATION_STEP_IDS.CLARIFICATIONS,
		name: "Clarifications",
		description: "Request clarifications from suppliers before finalising scores",
		info: "Raise any clarification questions with suppliers",
	},
	{
		id: EVALUATION_STEP_IDS.REVISIONS,
		name: "Revisions",
		description: "Review revised submissions after clarifications",
		info: "Review revised submissions from suppliers",
	},
	{
		id: EVALUATION_STEP_IDS.FINAL,
		name: "Final Evaluation",
		description: "Finalise your evaluation and select a preferred supplier",
		info: "Finalise your evaluation and select a preferred supplier",
	},
] as const;
